/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { ArrowForwardIos, ArrowBackIosNew } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useSwipeable } from 'react-swipeable'
import Image from './Image'

interface ImagesCarouselProps {
  options: string[]
  width: number
  height: number
  errorWidth?: number | string
  errorHeight?: number | string
}

function ImagesCarousel(props: ImagesCarouselProps) {
  const { options, width, height, errorHeight, errorWidth } = props

  const SWIPABLE_CONFIG = {
    delta: 10,
    preventScrollOnSwipe: false,
    trackTouch: true,
    trackMouse: true,
    rotationAngle: 0,
    swipeDuration: Infinity, //
    touchEventOptions: { passive: true },
  }

  const handlers = useSwipeable({
    onSwipedLeft: () => handleChangeIndex(current + 1),
    onSwipedRight: () => handleChangeIndex(current - 1),
    ...SWIPABLE_CONFIG,
  })

  const myRef = React.useRef()

  const refPassthrough = (el) => {
    handlers.ref(el)
    myRef.current = el
  }

  const [images] = React.useState(options)
  const [current, setCurrent] = React.useState(0)

  const handleChangeIndex = (index) => {
    if (index > images?.length - 1) setCurrent(0)
    else if (index < 0) setCurrent(images?.length - 1)
    else setCurrent(index)
  }

  const CALCULATED_TOP = `calc(${height / 2}px - 20px)`

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        width: '100%',
        maxWidth: `${width}px`,
        height: '100%',
        maxHeight: `${height}px`,
        borderRadius: '17px',
      }}
    >
      {images?.length > 1 ? (
        <>
          <ArrowBackIosNew
            onClick={() => handleChangeIndex(current - 1)}
            sx={{
              position: 'absolute',
              top: CALCULATED_TOP,
              left: 5,
              zIndex: 100,
              cursor: 'pointer',
              stroke: 'white',
              strokeWidth: 2,
              width: 20,
              height: 35,
              '&:hover': {
                filter: `drop-shadow(0 0 10px  rgba(0,0,0,0.8))`,
              },
            }}
          />
          <ArrowForwardIos
            onClick={() => handleChangeIndex(current + 1)}
            sx={{
              position: 'absolute',
              top: CALCULATED_TOP,
              right: 5,
              zIndex: 100,
              cursor: 'pointer',
              stroke: 'white',
              strokeWidth: 2,
              width: 20,
              height: 35,
              '&:hover': {
                filter: `drop-shadow(0 0 10px  rgba(0,0,0,0.8))`,
              },
            }}
          />
        </>
      ) : null}
      <Box
        {...handlers}
        ref={refPassthrough}
        sx={{
          width: `${width}px`,
          height: `${height}px`,
          zIndex: 99,
          backgroundColor: 'transparent',
        }}
      >
        {images?.length ? (
          <Image
            src={images?.[current]}
            height={height}
            width={width}
            errorWidth={errorWidth}
            errorHeight={errorHeight}
          />
        ) : null}
      </Box>
    </Box>
  )
}

export default ImagesCarousel

ImagesCarousel.propTypes = {}
